module.exports = __webpack_public_path__ + "img/bg.8120ccb9.png";